import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import { slugify } from "../../utils/slugify.js";
import type { Locale } from "../Locale.js";
import { categoryPathMap, getCataloguePath } from "./getCataloguePath.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getCatalogueCategoryPath(locale: Locale, categorySlug: string): string {
	const pathMap = sameValueForEveryLocale(`${categoryPathMap[locale]}/${slugify(categorySlug)}`);
	return getPathInLocale(locale, pathMap);
}
